import type { ReactNode } from "react";
import { Icon } from "../Icon.tsx";
import { estadoAtencao, estadoNegativo, estadoOutros } from "../icons/index.ts";
import { classes } from "../classes.ts";
import styles from "./Banner.module.css";

type BannerTone = "atencao" | "negativo" | "outros";

const icons = { atencao: estadoAtencao, negativo: estadoNegativo, outros: estadoOutros } as const;

export function Banner({ tone, children, action }: { readonly tone: BannerTone; readonly children: ReactNode; readonly action?: ReactNode }) {
  return (
    <div className={classes(styles.banner, styles[tone])} role="status">
      <Icon svg={icons[tone]} size={20} className={styles.icon} />
      <p className={styles.text}>{children}</p>
      {action === undefined ? null : <span className={styles.action}>{action}</span>}
    </div>
  );
}
